import { observer } from "mobx-react";
import React from "react";
import { Form, Row } from 'react-bootstrap';
import { ToggleButton } from '@common/components/forms';
import { UserModel } from "@common/models";
import { useFormContext, useWatch } from "react-hook-form";
import { YesNoConfirmModal } from "@common/components/modals";

interface IUserFlagsProps {
    isEditing?: boolean;
    showModal: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const UserFlags = observer(({ isEditing, showModal, onCancel, onConfirm }: IUserFlagsProps) => {
    const { register, control } = useFormContext<UserModel>();
    
    const [optInToAudioRecording] = useWatch({ control, name: [ "optInToAudioRecording"]});

    return (<>
        {showModal && <YesNoConfirmModal
            visible={showModal}
            busy={false}
            title="Confirm users consent for AI recording during a pet's visit"
            description="By saving, I am confirming that this partner has a signed consent to record conversations for medical documentation purposes."
            onConfirm={onConfirm}
            onCancel={onCancel} />}
        <Row className="d-flex flex-column">
            <div className="d-flex flex-row">
                <Form.Label className="mb-0 mt-3 me-2 p-0">Allow AI Recording For Medical Documentation:</Form.Label>
                <ToggleButton
                    {...register("optInToAudioRecording")}
                    defaultChecked={optInToAudioRecording}
                    noSlider={!isEditing} />
            </div>
        </Row>
    </>)
});
